import { render, staticRenderFns } from "./CardWeekend.vue?vue&type=template&id=b34001a0&"
import script from "./CardWeekend.vue?vue&type=script&lang=js&"
export * from "./CardWeekend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports